var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.52734 15.4487C6.98568 14.4487 9.33984 13.9487 11.5898 13.9487C13.8398 13.9487 16.1732 14.4487 18.5898 15.4487C21.0482 16.4071 22.2773 17.6779 22.2773 19.2612V21.9487H0.902344V19.2612C0.902344 17.6779 2.11068 16.4071 4.52734 15.4487ZM15.3398 9.69873C14.2982 10.7404 13.0482 11.2612 11.5898 11.2612C10.1315 11.2612 8.88151 10.7404 7.83984 9.69873C6.79818 8.65706 6.27734 7.40706 6.27734 5.94873C6.27734 4.4904 6.79818 3.2404 7.83984 2.19873C8.88151 1.1154 10.1315 0.57373 11.5898 0.57373C13.0482 0.57373 14.2982 1.1154 15.3398 2.19873C16.3815 3.2404 16.9023 4.4904 16.9023 5.94873C16.9023 7.40706 16.3815 8.65706 15.3398 9.69873Z",
    fill: "#4585FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.a4cf29daac5292da971e6b2fdfd4b510.svg";
export { ForwardRef as ReactComponent };